// src/helpers/confirmWord.js
//
// Typed confirmations ("Type ARCHIVE below to confirm"). The prompt text is
// translated, so users may type the word in their own language. Accept the
// English word, its known translations, or the word shown in the current
// prompt's placeholder ("Type ARCHIVE", "Tipo ARQUIVO", "Digite ARQUIVO").
// The word must be typed in capitals, as the prompt shows it; surrounding
// spaces are ignored.

const TRANSLATIONS = {
  ACTIVATE: ['ATIVAR'],
  ARCHIVE: ['ARQUIVO', 'ARQUIVAR'],
  DEACTIVATE: ['DESATIVAR'],
  DELETE: ['EXCLUIR', 'DELETAR', 'APAGAR'],
  DESTROY: ['DESTRUIR'],
  INVITE: ['CONVITE', 'CONVIDAR'],
  REMOVE: ['REMOVER'],
  REVOKE: ['REVOGAR'],
  SEND: ['ENVIAR'],
  UNARCHIVE: ['DESARQUIVAR'],
  VERIFY: ['VERIFICAR'],
}

function normalize(value) {
  return String(value || '').trim()
}

/** The upper-case word a placeholder asks for, e.g. "Tipo ARQUIVO" → "ARQUIVO". */
export function wordFromPlaceholder(placeholder) {
  const words = String(placeholder || '').match(/[A-ZÀ-Ý]{3,}/g)
  return words ? words[words.length - 1] : ''
}

/**
 * True if `value` confirms `word` (English, e.g. 'ARCHIVE').
 * Pass the prompt's translated placeholder so whatever word it shows is accepted too.
 */
export function matchesConfirmWord(value, word, placeholder) {
  const typed = normalize(value)
  if (!typed) return false
  const accepted = new Set([word, ...(TRANSLATIONS[word] || [])].map(normalize))
  const shown = wordFromPlaceholder(placeholder)
  if (shown) accepted.add(normalize(shown))
  return accepted.has(typed)
}
